import { render, staticRenderFns } from "./PacienteNotas.vue?vue&type=template&id=03a254cc&"
import script from "./PacienteNotas.vue?vue&type=script&lang=js&"
export * from "./PacienteNotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports